import { useMemo } from "react";
import { Modal } from "rsuite";
import { Button, SelectPicker } from "../../";

/**
 * Simple modal for changing export type with file type selection
 */
export default function ChangeExportTypeModal({
  open,
  onClose,
  fileTypes,
  selectedFileType,
  onFileTypeChange,
  onConfirm,
  loading = false
}) {
   
    const fileTypesData = useMemo(() => {
        if(!fileTypes || fileTypes.length === 0) {
            return [];
        }
        return fileTypes.map(fileType => ({
            label: fileType.typeName,
            value: fileType.fileTypeId
        }));
    }, [fileTypes]);

  return (
    <Modal 
      open={open} 
      onClose={onClose} 
      backdrop="static" 
      keyboard={true} 
      overflow={false}
    >
      <Modal.Header>
        <h5>Change Export Type</h5>
      </Modal.Header>
      
      <Modal.Body style={{ height: 100 }}>
        <p>Please select a new export type for this transaction:</p>
        <div style={{ marginTop: "15px" }}>
          <SelectPicker
            data={fileTypesData}
            valueKey="value"
            labelKey="label"
            defaultValue={selectedFileType?.id}
            onChange={onFileTypeChange}
            testid="export-type-select"
            placeholder="Select an export type..."
            style={{ width: "100%" }}
          />
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button
          text="Confirm"
          appearance="primary"
          onClick={onConfirm}
          disabled={!selectedFileType || loading}
          data-testid="confirm-export-type-btn"
        />
        <Button
          text="Cancel"
          appearance="subtle"
          color="red"
          onClick={onClose}
          data-testid="cancel-export-type-btn"
        />
      </Modal.Footer>
    </Modal>
  );
}